import { db } from "firebase-config";
import { onSnapshot, collection } from "firebase/firestore";
import { nonUndefined } from "Utility";
import {
  matchCollectionName,
  tournamentCollectionName,
} from "./collectionNames";
import { mapMatch } from "db/mapping/match/FsMatch";
import { FsMatch } from "db/model/match/FsMatch";
import { Dispatch } from "@reduxjs/toolkit";
import { updateMatches } from "app/slices/MatchSlice";

export const setupMatchSnapshot = (
  dispatch: Dispatch,
  tournamentId: string
) => {
  onSnapshot(
    collection(db, tournamentCollectionName, tournamentId, matchCollectionName),
    (querySnapshot) => {
      const matches = nonUndefined(
        querySnapshot
          .docChanges()
          .map((d) => mapMatch(d.doc.data() as FsMatch, d.doc.id, tournamentId))
      );

      dispatch(
        updateMatches({
          matches,
          tournamentId,
        })
      );
    }
  );
};
